import React from 'react';
import { GraduationCap, Building2, Users, Heart } from 'lucide-react';
const audiences = [{
  title: 'Schools & Teams',
  description: 'Spirit wear, uniforms, and fundraising merchandise for local schools and sports leagues.',
  icon: GraduationCap,
  color: 'bg-blue-100 text-blue-600'
}, {
  title: 'Local Businesses',
  description: 'Professional branded apparel, uniforms, and promotional items to help your business stand out.',
  icon: Building2,
  color: 'bg-purple-100 text-purple-600'
}, {
  title: 'Families & Gifts',
  description: 'Personalized items for reunions, vacations, birthdays, weddings, and baby showers.',
  icon: Heart,
  color: 'bg-pink-100 text-pink-600'
}, {
  title: 'Community Groups',
  description: 'Custom gear for non-profits, churches, events, and volunteer organizations.',
  icon: Users,
  color: 'bg-teal-100 text-teal-600'
}];
export function WhoWeServe() {
  return <section id="who-we-serve" className="py-20 relative overflow-hidden bg-cover bg-center" style={{
    backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/kUKhh4GiSseLkSSonGv2By/WhoWeServe-bg.png)',
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  }} data-id="element-259">
      {/* Blur layer */}
      <div className="absolute inset-0 bg-cover bg-center" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/kUKhh4GiSseLkSSonGv2By/WhoWeServe-bg.png)',
      filter: 'blur(8px)',
      transform: 'scale(1.1)'
    }} data-id="element-260"></div>

      {/* Light overlay for text readability - strongest in center */}
      <div className="absolute inset-0" style={{
      background: 'radial-gradient(ellipse at center, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0.3) 50%, rgba(255, 255, 255, 0.4) 100%)'
    }} data-id="element-261"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-262">
        <div className="text-center mb-16" data-id="element-263">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-264">
            Who We Serve
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-265">
            Providing custom apparel and personalized products since 2014.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-266">
          {audiences.map(item => <div key={item.title} className="flex flex-col items-center text-center p-6 rounded-2xl bg-white/80 backdrop-blur-sm shadow-sm hover:bg-white hover:shadow-md transition-all" data-id="element-267">
              <div className={`h-16 w-16 rounded-2xl flex items-center justify-center mb-6 ${item.color}`} data-id="element-268">
                <item.icon className="h-8 w-8" data-id="element-269" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-270">
                {item.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-271">
                {item.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}